import PropTypes from "prop-types";

export const sectionShape = PropTypes.shape({
  section_label: PropTypes.string,
});
